<template>
  <modal
    class="editCreditLimit"
    name="emailToBranch"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
  >
    <div class="text-center py-5">
      <h4>{{ $t("text.addEmailToBranch.mapUser") }}</h4>
    </div>
    <div class="sign_up_form_section">
      <form>
        <div class="row justify-content-center">
          <div class="col-md-7">
            <div class="price_change_input_wrapper" ref="e_div">
              <input
                type="email"
                v-model="email"
                :placeholder="$t('text.addEmailToBranch.email')"
                @blur="captureFormEvents($event)"
              />
            </div>
            <div ref="er"></div>
          </div>
        </div>
        <div class="row justify-content-center mt-3">
          <div class="col-md-7">
            <div class="price_change_input_wrapper" ref="r_div">
              <select v-model="role" @change="checkRole">
                <option value="select role" disabled>
                  {{ $t("text.addEmailToBranch.selectRole") }}
                </option>
                <option value="CompanyAdmin">
                  {{ $t("text.addEmailToBranch.companyAdmin") }}
                </option>
                <option value="BranchManager">
                  {{ $t("text.addEmailToBranch.branchManager") }}
                </option>
                <option value="Customer">
                  {{ $t("text.addEmailToBranch.customer") }}
                </option>
              </select>
            </div>
            <div ref="re"></div>
          </div>
        </div>
        <div class="text-center mt-5">
          <button
            class="show_more_button remove_text_decoration"
            @click="addUserToBranch($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.addEmailToBranch.mapUser") }} <span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 656;

export default {
  name: "emailToBranch",
  props: ["branchId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      users: [],
      user: "",
      role: "select role",
      email: "",
      branchid: "",
      addEmailBranchId: null,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
    };
  },
  watch: {
    addEmailBranchId: function (newVal, oldVal) {
      this.branchid = oldVal;
    },
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
    });
    this.$eventHub.$on("addEmailBranchId", (branchId) => {
      this.addEmailBranchId = branchId;
    });
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  mounted() {
    this.getCompanyUsers();
  },
  methods: {
    checkRole(event) {
      event.preventDefault();
      if (event.target.value !== "select role") {
        this.$refs.re.style.display = "none";
        this.$refs.re.innerHTML = "";
        this.$refs.r_div.style.border = "1px solid rgb(75, 44, 114)";
        return;
      }
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    captureFormEvents($event) {
      if (
        $event.target.placeholder === this.$t("text.addEmailToBranch.email")
      ) {
        if ($event.target.value === "") {
          this.$refs.er.style.display = "block";
          this.$refs.er.innerHTML = this.$t("text.errors.emailMissing");
          this.$refs.e_div.style.border = "1px solid red";
          this.$refs.er.style.color = "red";
          this.formIsValid = false;
        } else {
          if (this.validEmail($event.target.value)) {
            this.$refs.er.style.display = "none";
            this.$refs.er.innerHTML = "";
            this.$refs.e_div.style.border = "1px solid rgb(75, 44, 114)";
            this.formIsValid = true;
          } else {
            this.$refs.er.style.display = "block";
            this.$refs.er.innerHTML = this.$t("text.errors.invalidEmail");
            this.$refs.e_div.style.border = "1px solid red";
            this.$refs.er.style.color = "red";
          }
        }
      }
    },

    closeModal() {
      this.$modal.hide("emailToBranch");
    },
    addUserToBranch($event) {
      $event.preventDefault();
      if (!this.email) {
        this.$refs.er.style.display = "block";
        this.$refs.er.innerHTML = this.$t("text.errors.emailMissing");
        this.$refs.e_div.style.border = "1px solid red";
        this.$refs.er.style.color = "red";
        this.formIsValid = false;
      } else {
        if (!this.validEmail(this.email)) {
          this.$refs.er.style.display = "block";
          this.$refs.er.innerHTML = this.$t("text.errors.invalidEmail");
          this.$refs.e_div.style.border = "1px solid red";
          this.$refs.er.style.color = "red";
          return;
        } else {
          this.$refs.er.style.display = "none";
          this.$refs.er.innerHTML = "";
          this.$refs.e_div.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if (this.role === "select role") {
        this.$refs.re.style.display = "block";
        this.$refs.re.innerHTML = this.$t(
          "text.addEmailToBranch.selectRoleError"
        );
        this.$refs.r_div.style.border = "1px solid red";
        this.$refs.re.style.color = "red";
        return;
      }

      $(".loader").show();

      let data = {
        email: this.email,
        role: this.role,
        branchId: this.addEmailBranchId,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/AddUserToRole/${this.$route.query.companyId}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.closeModal();
          this.$toast.open({
            message: this.$t("text.addEmailToBranch.successfullyMapped"),
            type: "success",
            duration: 5000,
          });
          this.email = null;
          this.role = null;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    getCompanyUsers() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Users/${this.$route.query.companyId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.isButtonDisabled = false;
        })
        .catch((error) => {});
    },
  },
};
</script>
